import { ApolloError } from '@apollo/client'
import { AlertMessageType } from './getAlertErrorMessage'
import { hasCartMutationTimedOut } from './cartMutationTimeout'

export const ABORT_ERROR = 'AbortError'
/**
 * Validates the error message from the Apollo client and returns the appropriate alert message type.
 * If the error is an abort error, it returns undefined.
 *
 * An abort the cart mutation timeout made (see `utils/cartMutationTimeout.ts`)
 * is a failure, not a superseded request, so it returns the network type. Pass
 * the request's `signal` for that check: where the browser carries no abort
 * reason, a timed-out fetch rejects with the same `AbortError` as a superseded
 * one, and the error alone cannot tell them apart.
 *
 * @param error - The ApolloError object to validate.
 * @param defaultError - The default alert message type to return if the error is not a network error.
 * @param signal - The signal the request was sent with, if any.
 * @returns The alert message type to be displayed, or undefined if the error is an abort error.
 */
export const validateApolloErrorCartAction = (
  error: ApolloError,
  defaultError: AlertMessageType,
  signal?: AbortSignal,
): AlertMessageType | undefined => {
  if (hasCartMutationTimedOut(signal)) {
    return AlertMessageType.Network
  }
  if (error.cause?.name !== ABORT_ERROR) {
    return error.networkError ? AlertMessageType.Network : defaultError
  }
}

export default validateApolloErrorCartAction
